import script from "./CustomerDictionaryTypesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDictionaryTypesModal.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDictionaryTypesModal.vue?vue&type=style&index=0&id=a9b0aeb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b0aeb2"]])

export default __exports__